import { html } from "lit-html";

export default html` <svg
	width="10"
	height="2"
	viewBox="0 0 10 2"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<g clip-path="url(#clip0_350_67124)">
		<path d="M0.793427 1H9.20676" stroke="#202A36" stroke-width="1.5" stroke-linecap="round" />
	</g>
	<defs>
		<clipPath id="clip0_350_67124">
			<rect width="10" height="2" fill="white" />
		</clipPath>
	</defs>
</svg>`.strings.join("");
